<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <template v-for="(item, index) in levelList">
        <el-breadcrumb-item v-if="item.meta.title" :key="item.path">
          <span
            v-if="
              item.redirect === 'noredirect' || index == levelList.length - 1
            "
            class="no-redirect"
          >
            {{ item.meta.title }}
          </span>
          <span
            class="routerNav"
            v-else
            @click.stop="clickNavbarItem(item, index)"
          >
            {{ item.meta.title }}
          </span>
        </el-breadcrumb-item>
      </template>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb();
  },
  data() {
    return {
      levelList: null,
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.name);
      const first = matched[0];
      if (first && first.name !== "dashboard") {
        matched = [{ path: "/dashboard", meta: { title: "首页" } }].concat(
          matched
        );
      }

      this.levelList = matched;
      // console.log(matched);
    },
    clickNavbarItem(item, index) {
      if (item.path === "/dashboard") {
        this.$router.replace({ path: item.path });
      } else {
        this.$router.go(-1);
        item.redirect = "noredirect";
        this.levelList.splice(item, index, 1);
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 70px;
  margin-left: 10px;
  .no-redirect {
    color: #090909;
    cursor: text;
  }
  .routerNav {
    color: #acacac;
    font-weight: normal;

    &:hover {
      color: #0366ff;
      cursor: pointer;
    }
  }
}
</style>
